const ResizeIcon = () => (
  <svg
    width={8}
    height={8}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.25">
      <line
        x1="7"
        y1="0.707107"
        x2="0.707107"
        y2="7"
        stroke="#4D607C"
        strokeLinecap="round"
      />
      <line
        x1="7"
        y1="4.70711"
        x2="4.70711"
        y2="7"
        stroke="#4D607C"
        strokeLinecap="round"
      />
    </g>
  </svg>
)

export default ResizeIcon
